import React from "react";
import { Loader2 } from "lucide-react";

interface SessionLoadingSpinnerProps {
  isVisible?: boolean;
}

const SessionLoadingSpinner = ({
  isVisible = true,
}: SessionLoadingSpinnerProps) => {
  return (
    <div
      className={`fixed inset-0 bg-gray-50 flex items-center justify-center transition-opacity duration-500 ${
        isVisible ? "opacity-100" : "opacity-0"
      }`}
    >
      <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
    </div>
  );
};

export default SessionLoadingSpinner;
